import React from "react";
import { StyledButton } from "components/atoms/BorderButton/BorderButton.styles";

export default function BorderButton(props) {
  return <StyledButton {...props}></StyledButton>;
}
